import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";

import { T } from "../../constants";
import { useUi } from "../../ui";
import Field from "../../vip/components/Field";

const emptyContact = {
  name: "",
  type: "BOOKING",
  description: "",
  phone: "",
  email: "",
};

const useStyles = makeStyles({
  title: { margin: 0, fontSize: 16, fontWeight: 600, color: T.fg },
  body: { marginTop: 16, display: "grid", gap: 12 },
});

export default function AddContactForm({ disabled, onAdd }) {
  const s = useStyles();
  const ui = useUi();
  const [contact, setContact] = useState(emptyContact);
  const [submitting, setSubmitting] = useState(false);

  const setField = (field) => (event) => {
    const { value } = event.target;
    setContact((current) => ({ ...current, [field]: value }));
  };

  const isBlocked = disabled || submitting;

  const submit = async (event) => {
    event.preventDefault();
    if (!contact.name.trim() || isBlocked) return;

    setSubmitting(true);
    try {
      const saved = await onAdd(contact);
      if (saved !== false) setContact(emptyContact);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div style={{ padding: 20 }}>
      <h2 className={s.title}>Add contact</h2>
      <form className={s.body} onSubmit={submit}>
        <Field label="Name">
          <input value={contact.name} disabled={isBlocked} onChange={setField("name")} placeholder="Spa Reception" className={ui.field} />
        </Field>
        <Field label="Contact type">
          <select value={contact.type} disabled={isBlocked} onChange={setField("type")} className={ui.field}>
            <option value="BOOKING">Booking</option>
            <option value="SANCTIONED_PLATE">Sanctioned plate</option>
          </select>
        </Field>
        <Field label="SMS number">
          <input value={contact.phone} disabled={isBlocked} onChange={setField("phone")} placeholder="+61 4xx xxx xxx" className={ui.field} />
        </Field>
        <Field label="Email">
          <input value={contact.email} disabled={isBlocked} onChange={setField("email")} placeholder="team@hotel.com" className={ui.field} />
        </Field>
        <Field label="Description">
          <input value={contact.description} disabled={isBlocked} onChange={setField("description")} placeholder="Short internal note" className={ui.field} />
        </Field>
        <button type="submit" disabled={!contact.name.trim() || isBlocked} className={ui.primaryBtn} style={{ width: "100%" }}>
          Add contact
        </button>
      </form>
    </div>
  );
}
